import {branding} from '@/lib/plugins/theme'
import {Theme} from '@/lib/kepler/interfaces'

const theme: Theme = branding.theme
export const customCss = branding.customCss
export const gradientAngle = branding.gradientAngle
export const customClasses = branding.customClasses
export const dark = branding.dark
export default theme
